import { api } from '@/scripts/api';
export const StorefrontService = {

    get(agencyId){
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/agency-storefront/agency/${agencyId}/designer`;
            api
            .get(service)
            .then(resolve)
            .catch(reject);
        });
    },

    post(payload){
        return new Promise((resolve, reject) => {
            const endpoint = '/ms/marketplace/v1/agency-storefront/';
            api
            .post(endpoint,payload)
            .then(resolve)
            .catch(reject);
        });
    },

    patch(agencyId, payload){
        return new Promise((resolve, reject) => {
            const service = '/ms/marketplace/v1/agency-storefront/';
            const endpoint = `${service}${agencyId}`;
            api
            .msPatch(endpoint,payload)
            .then(resolve)
            .catch(reject);
        });
    },
    
    getById(id, options={}) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/agency-storefront/agency/${id}?${options}`;            
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    getAll(options = {}) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/agency-storefront?${options}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    getStorefrontRequests(options = {}) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/applications?${options}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    getStorefrontRequestsByAgencyId(agencyId, config = {}) {
        return new Promise((resolve, reject) => {
            const service  = `/ms/marketplace/v1/applications/agencies/${agencyId}`;
            const endpoint = api.applyNodeDataParams(service, config);
            
            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        });
    },

    deny(agencyId, reason) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/applications/agencies/${agencyId}/deny`;
            api
                .post(service, reason)
                .then(resolve)
                .catch(reject);
        });
    },

    revoke(agencyId, reason) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/applications/agencies/${agencyId}/revoke`;
            api
                .post(service, reason)
                .then(resolve)
                .catch(reject);
        });
    },

    approve(agencyId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/applications/agencies/${agencyId}/approve`;
            api
                .post(service)
                .then(resolve)
                .catch(reject);
        });
    },

    apply(agencyId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/applications/agencies/${agencyId}/apply`;
            api
                .post(service)
                .then(resolve)
                .catch(reject);
        });
    },

    getAgencyApplication(agencyId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketplace/v1/applications/agencies/${agencyId}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    // This is the only method that uses .NET API due to where the data is stored
    getStorefrontSolutionsTotal(agencyId) {
        return new Promise((resolve, reject) => {
            const service = `/api/Agencies/${agencyId}/Solutions/Storefront/Total`
            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    }
}